import React from "react";
import Box from "@mui/material/Box";
import Alert from "@mui/material/Alert";
import IconButton from "@mui/material/IconButton";
import Collapse from "@mui/material/Collapse";
import CloseIcon from "@mui/icons-material/Close";
import "./CourseMasterData.css";
import { Typography } from "@mui/material";
function BatchScheduleAlert(props) {
 return (
  <Box
   sx={{ width: "50%", position: "fixed", top: 0, right: 0 }}
   className="freeze-alert"
  >
   <Collapse in={props.openFreezeAlert}>
    <Alert
     action={
      <IconButton
       aria-label="close"
       color="inherit"
       size="small"
       onClick={() => {
        props.setOpenFreezeAlert(false);
       }}
      >
       <CloseIcon fontSize="inherit" />
      </IconButton>
     }
     sx={{
      mb: 10,
      background: "linear-gradient(45deg, #5D3FD3, #800080)",
      color: "white",
     }}
    >
     <Typography sx={{ margin: "10px 0px 10px 0px", fontSize: "14px" }}>
      {" "}
      This session batch has scheduled, remaining waitlisted nominees can be
      scheduled in this session as well as in the upcoming sessions.
     </Typography>
    </Alert>
   </Collapse>
  </Box>
 );
}

export default BatchScheduleAlert;
